var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-3 pb-0 pb-lg-5 px-lg-0 position-relative" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex d-lg-none sparepartsproductfabricselection__filter__filter-icon position-absolute",
          on: {
            click: function ($event) {
              return _vm.toggleFilter(true)
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.162",
                height: "14.897",
                viewBox: "0 0 16.162 14.897",
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "filter",
                  d: "M16.114,9.964a.49.49,0,0,0-.443-.281H.489a.49.49,0,0,0-.378.8l5.836,7.079V24.09a.49.49,0,0,0,.707.439L9.934,22.9a.49.49,0,0,0,.272-.438l.006-4.9,5.836-7.079A.49.49,0,0,0,16.114,9.964ZM9.345,17.075a.49.49,0,0,0-.112.311l-.006,4.774-2.3,1.14V17.387a.49.49,0,0,0-.112-.312L1.528,10.663h13.1Z",
                  transform: "translate(0 -9.683)",
                  fill: _vm.svgcolor2,
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.filtersLoaded.length > 1
        ? _c(
            "div",
            {
              staticClass:
                "position-fixed position-lg-static w-100 w-lg-auto top-0 sparepartsproductfabricselection__filter d-flex flex-wrap",
              class: [
                _vm.filterIsOpen ? "open" : "",
                _vm.loaded
                  ? "sparepartsproductfabricselection__filter__loaded"
                  : "",
                "sparepartsproductfabricselection__filter--" + _vm.theme,
                "bg-" + _vm.theme,
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "backToSection position-relative w-100 d-flex px-1 py-3 d-lg-none justify-content-between justify-content-lg-start align-items-center",
                  class: "backToSection--" + _vm.theme,
                },
                [
                  _vm.theme == "white"
                    ? [
                        _c(
                          "svg",
                          {
                            staticClass: "position-absolute",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "6.774",
                              height: "5",
                              viewBox: "0 0 6.774 5",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "play-button",
                                d: "M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z",
                                transform: "translate(6.774) rotate(90)",
                                fill: "#000",
                                opacity: "0.8",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "d-none cross position-absolute",
                            attrs: {
                              height: "12",
                              viewBox: "0 0 512 512",
                              width: "12",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleFilter(false)
                              },
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "_02_User",
                                  "data-name": "02 User",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "#000",
                                    d: "m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    fill: "#000",
                                    d: "m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "svg",
                          {
                            staticClass: "position-absolute",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "6.774",
                              height: "5",
                              viewBox: "0 0 6.774 5",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                id: "play-button",
                                d: "M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z",
                                transform: "translate(6.774) rotate(90)",
                                fill: "#fff",
                                opacity: "0.8",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "d-none cross position-absolute",
                            attrs: {
                              height: "12",
                              viewBox: "0 0 512 512",
                              width: "12",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleFilter(false)
                              },
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "_02_User",
                                  "data-name": "02 User",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "#fff",
                                    d: "m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    fill: "#fff",
                                    d: "m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ],
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "py-3 pl-5",
                      class: "text-primary-" + _vm.theme,
                      on: {
                        click: function ($event) {
                          return _vm.toggleFilter(false)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("pagination.previous")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "py-3 px-5 text-right",
                      class: "text-primary-" + _vm.theme,
                      on: {
                        click: function ($event) {
                          return _vm.setFilter("all", "none")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("general.setbackall")))]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column flex-lg-row flex-wrap w-100 w-lg-auto vh-100 h-lg-auto px-4 p-lg-0",
                },
                [
                  _vm._l(_vm.filtersLoaded, function (filter, index) {
                    return _c(
                      "div",
                      {
                        key: filter.filterId,
                        staticClass:
                          "sparepartsproductfabricselection__filter__item position-static position-lg-relative mr-0 mr-lg-3",
                        class: "bg-third-fourth-hover--" + _vm.theme,
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "sparepartsproductfabricselection__filter__item__selected d-flex justify-content-between align-items-center",
                            on: {
                              click: function ($event) {
                                _vm.underMenuOpen = index
                              },
                            },
                          },
                          [
                            filter.selected == "none"
                              ? [_c("p", [_vm._v(_vm._s(filter.label))])]
                              : [
                                  filter.children[
                                    filter.selected
                                  ].hasOwnProperty("title")
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "d-none d-lg-flex align-items-center",
                                        },
                                        [
                                          filter.children[
                                            filter.selected
                                          ].hasOwnProperty("hex")
                                            ? [
                                                filter.children[filter.selected]
                                                  .hex != null &&
                                                filter.children[filter.selected]
                                                  .hex != ""
                                                  ? _c("span", {
                                                      staticClass:
                                                        "hexcircle mr-3",
                                                      style: {
                                                        backgroundColor:
                                                          filter.children[
                                                            filter.selected
                                                          ].hex,
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                filter.children[filter.selected]
                                                  .title
                                              ) +
                                              "\n                        "
                                          ),
                                        ],
                                        2
                                      )
                                    : _c(
                                        "p",
                                        { staticClass: "d-none d-lg-flex" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              filter.children[filter.selected]
                                            )
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "d-flex d-lg-none" }, [
                                    _vm._v(_vm._s(filter.label)),
                                  ]),
                                ],
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "6.774",
                                  height: "5",
                                  viewBox: "0 0 6.774 5",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    id: "play-button",
                                    d: "M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z",
                                    transform: "translate(6.774) rotate(90)",
                                    fill: _vm.svgcolor1,
                                    opacity: "0.8",
                                  },
                                }),
                              ]
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "underMenu position-absolute w-100 vh-100 h-lg-auto",
                            class: [
                              _vm.underMenuOpen == index ? "open" : "",
                              "bg-" + _vm.theme,
                            ],
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "backToSection position-relative w-100 d-flex px-1 py-3 d-lg-none justify-content-between align-items-center",
                                class: "backToSection--" + _vm.theme,
                              },
                              [
                                _vm.theme == "white"
                                  ? [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "position-absolute",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "6.774",
                                            height: "5",
                                            viewBox: "0 0 6.774 5",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              id: "play-button",
                                              d: "M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z",
                                              transform:
                                                "translate(6.774) rotate(90)",
                                              fill: "#000",
                                              opacity: "0.8",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "d-none cross position-absolute",
                                          attrs: {
                                            height: "12",
                                            viewBox: "0 0 512 512",
                                            width: "12",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "_02_User",
                                                "data-name": "02 User",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#000",
                                                  d: "m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  fill: "#000",
                                                  d: "m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "position-absolute",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "6.774",
                                            height: "5",
                                            viewBox: "0 0 6.774 5",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              id: "play-button",
                                              d: "M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z",
                                              transform:
                                                "translate(6.774) rotate(90)",
                                              fill: "#fff",
                                              opacity: "0.8",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "d-none cross position-absolute",
                                          attrs: {
                                            height: "12",
                                            viewBox: "0 0 512 512",
                                            width: "12",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "_02_User",
                                                "data-name": "02 User",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#fff",
                                                  d: "m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  fill: "#fff",
                                                  d: "m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "py-3 pl-5",
                                    class: "text-primary-" + _vm.theme,
                                    on: {
                                      click: function ($event) {
                                        _vm.underMenuOpen = "undefined"
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.t("pagination.previous")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "py-3 px-5 text-right",
                                    class: "text-primary-" + _vm.theme,
                                    on: {
                                      click: function ($event) {
                                        return _vm.setFilter(index, "none")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.t("general.setback")))]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "w-100 px-4 px-lg-0 pt-lg-3 mb-0 h-100 h-lg-auto",
                              },
                              [
                                _vm._l(
                                  filter.children,
                                  function (filterchild, index2) {
                                    return _c(
                                      "li",
                                      {
                                        key: index2,
                                        staticClass:
                                          "d-flex align-items-center justify-content-between",
                                        class:
                                          "bg-third-fourth-hover--" + _vm.theme,
                                        on: {
                                          click: function ($event) {
                                            return _vm.setFilter(index, index2)
                                          },
                                        },
                                      },
                                      [
                                        filterchild.hasOwnProperty("title")
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center",
                                                class: [
                                                  filter.selected == index2
                                                    ? "selected"
                                                    : "",
                                                ],
                                              },
                                              [
                                                filterchild.hasOwnProperty(
                                                  "hex"
                                                )
                                                  ? [
                                                      filterchild.hex != null &&
                                                      filterchild.hex != ""
                                                        ? _c("span", {
                                                            staticClass:
                                                              "hexcircle mr-3",
                                                            style: {
                                                              backgroundColor:
                                                                filterchild.hex,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                                " +
                                                    _vm._s(filterchild.title) +
                                                    "\n                            "
                                                ),
                                              ],
                                              2
                                            )
                                          : _c(
                                              "p",
                                              {
                                                class: [
                                                  filter.selected == index2
                                                    ? "selected"
                                                    : "",
                                                ],
                                              },
                                              [_vm._v(_vm._s(filterchild))]
                                            ),
                                        _vm._v(" "),
                                        filter.selected == index2
                                          ? _c(
                                              "svg",
                                              {
                                                staticClass: "d-flex d-lg-none",
                                                staticStyle: {
                                                  "enable-background":
                                                    "new 0 0 78.369 78.369",
                                                },
                                                attrs: {
                                                  version: "1.1",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  "xmlns:xlink":
                                                    "http://www.w3.org/1999/xlink",
                                                  x: "0px",
                                                  y: "0px",
                                                  width: "12px",
                                                  height: "12px",
                                                  viewBox: "0 0 78.369 78.369",
                                                  "xml:space": "preserve",
                                                },
                                              },
                                              [
                                                _c("g", [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: _vm.svgcolor2,
                                                      d: "M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704\n                                        c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704\n                                        C78.477,17.894,78.477,18.586,78.049,19.015z",
                                                    },
                                                  }),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "setback w-100 d-none d-lg-block position-absolute bottom-0 left-0 position-lg-static justify-content-center d-sm-none",
                                    class:
                                      "bg-third-fourth-hover--" + _vm.theme,
                                    on: {
                                      click: function ($event) {
                                        return _vm.setFilter(index, "none")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.t("general.setback")) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass:
                                      "w-100 d-flex d-lg-block position-absolute bottom-0 left-0 position-lg-static justify-content-center d-md-none d-lg-none d-xl-none",
                                  },
                                  [
                                    _vm.noFilterActive == false
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "showproduct-button py-3 px-5 mx-3 d-flex mt-0 mb-2 d-md-none into_basket into_basket--mobile justify-content-center",
                                            class: "bg-hover--" + _vm.theme,
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleFilter(false)
                                              },
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.t("general.use"))
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _vm.amount > 0
                                              ? _c("p", [
                                                  _vm._v(
                                                    " (" +
                                                      _vm._s(_vm.amount) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.t("general.results")
                                                      ) +
                                                      ")"
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "showproduct-button showproduct-button--else py-3 px-5 mx-3 d-flex mt-0 mb-2 d-md-none into_basket into_basket--mobile justify-content-center",
                                            class: "bg-hover--" + _vm.theme,
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleFilter(false)
                                              },
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(_vm.t("modal.close"))
                                              ),
                                            ]),
                                          ]
                                        ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "left-0 position-absolute px-3 w-100 showproduct-button__outer",
                    },
                    [
                      _vm.noFilterActive == false
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "showproduct-button py-3 px-5 d-flex mt-0 mb-4 d-md-none into_basket into_basket--mobile justify-content-center",
                              class: "bg-hover--" + _vm.theme,
                              on: {
                                click: function ($event) {
                                  return _vm.toggleFilter(false)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.t("general.use"))),
                              ]),
                              _vm._v(" "),
                              _vm.amount > 0
                                ? _c("p", [
                                    _vm._v(
                                      " (" +
                                        _vm._s(_vm.amount) +
                                        " " +
                                        _vm._s(_vm.t("general.results")) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "showproduct-button showproduct-button--else py-3 px-5 d-flex mt-0 mb-4 d-md-none into_basket into_basket--mobile justify-content-center",
                              class: "bg-hover--" + _vm.theme,
                              on: {
                                click: function ($event) {
                                  return _vm.toggleFilter(false)
                                },
                              },
                            },
                            [_c("p", [_vm._v(_vm._s(_vm.t("modal.close")))])]
                          ),
                    ]
                  ),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }